import { render, staticRenderFns } from "./NewReportFullView.vue?vue&type=template&id=ec560a7c&"
import script from "./NewReportFullView.vue?vue&type=script&lang=js&"
export * from "./NewReportFullView.vue?vue&type=script&lang=js&"
import style0 from "./NewReportFullView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports